import React from 'react';
import { Popconfirm as AntPopconfirm } from 'antd';

/**
 * Wrapper component for Ant Design Popconfirm
 *
 * This wrapper allows us to easily replace Ant Design in the future without changing all imports.
 * It preserves all Ant Design Popconfirm functionality including title, okText, cancelText, and onConfirm options.
 *
 * @component
 * @example
 * import { Popconfirm, Button } from '../GeneralComponents/ui';
 *
 * <Popconfirm
 *   title="Are you sure to delete this task?"
 *   onConfirm={handleConfirm}
 *   okText="Yes"
 *   cancelText="No"
 * >
 *   <Button>Delete</Button>
 * </Popconfirm>
 *
 * @see https://ant.design/components/popconfirm/ - Ant Design Popconfirm documentation
 */
const Popconfirm = (props) => {
  return (
    <AntPopconfirm
      {...props}
      overlayInnerStyle={{
        borderRadius: '16px',
        overflow: 'hidden',
        ...props.overlayInnerStyle,
      }}
    />
  );
};

export default Popconfirm;
